%content-before {
  content: "\2022";
}

.list {
  padding: 1px 0;
  margin-block: 0;
  overflow: hidden auto;
  padding-inline: 0 8px;

  li {
    display: flex;
    align-items: center;

    &::before {
      @extend %content-before;

      padding: 3px 8px 0 0;
    }
  }

  &.no-bullets {
    list-style-type: none;
    padding-inline-start: 0;
    margin: 0;

    li {
      &::before {
        content: none;
      }
    }
  }
}

.description {
  display: flex;
  font-size: var(--sm-font-size);
  line-height: 1;
}

.section {
  display: flex;
  flex-direction: column;
  line-height: normal;
  gap: 1px !important;

  &.section-virtual-list {
    margin: 3px 0;
    position: relative;
    padding: 0 10px 0 0;

    > span {
      margin: 0;
    }

    &.bullets {
      padding: 0 10px 0 4px;

      > span {
        margin: 0 0 0 14px;
      }

      &::before {
        @extend %content-before;

        position: absolute;
        top: 4px;
      }
    }
  }
}

.text-wrap-virtual-list {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:is(a) {
    color: inherit;
    text-decoration: underline;
  }
}

.wrap-array {
  display: flex;
  gap: 2px;
  margin: 0 6px 0 0;

  .label-array {
    color: var(--neutral-7-color);
  }
}

.text {
  display: flex;

  &.link {
    text-decoration: underline;
    cursor: pointer;
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
